/**
 * Product Form Components
 *
 */
var flag=false;
rebuyProducts={};
var loading = false;
let currentForm=document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('form');
window.currentProduct = currentForm ? JSON.parse(currentForm?.querySelector('[data-productJSON]')?.innerText) : null;
var productToggleUrls = {
    single: '',
    pack4: '',
    pack6: '',
    pack10: '',
}

window.allProductJson = {};
_triggerAttentiveEvent('product-view');
_keepColorSelected();
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');

    if(this.form != null) {

      this.form.querySelector('.color-dropdown-wrapper')?.addEventListener('click', (element) => {
        this.form?.querySelector('.variant-wrapper .color-menu')?.classList.toggle('d-none');
        this.form?.querySelector('.variant-wrapper .size-menu')?.classList.add('d-none');
      })

      this.form.querySelector('.size-dropdown-wrapper')?.addEventListener('click', (element) => {
        this.form?.querySelector('.variant-wrapper .size-menu')?.classList.toggle('d-none');
        this.form?.querySelector('.variant-wrapper .color-menu')?.classList.add('d-none');
      })

      // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.form.querySelector('[type="submit"]').addEventListener('click', this.onSubmitHandler.bind(this));
      this.cartElement = document.querySelector('ajax-cart');
      this.form.querySelector('[type="submit"]')?.classList.remove('disabled');
      document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.remove('disabled')
      this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

      this.productJson = JSON.parse(this.form?.querySelector('[data-productJSON]')?.innerText);

      this.form.querySelectorAll('[data-color-swatch] .color-swatch').forEach(ele => {
        ele.addEventListener('mouseover', () => {
          let title = ele.querySelector('[title]').getAttribute('title');
          let producttype = ele.closest('[data-color-type]')?.getAttribute('data-color-type')?.replace('U-', '');
          if (ele.closest('[data-color-type]') != null && ele.closest('[data-color-type]').querySelector('[data-color-name]') != null) {
            ele.closest('[data-color-type]').querySelector('[data-color-name]').innerHTML = title.toLowerCase().replaceAll(producttype.toLowerCase(), '').replace('shorts', '').replace('vip', 'VIP').replace('boss 2.0', '').replace('icon 2.0', '').replace('rib tank', '').replace('luxe bralette', '').replace('u-', '').replace('sleep short sleeve tee', '').replace('sleep set long sleeve', '').replace('sleep set short sleeve', '').replace('sleep', '').replace('4-pack', '').replace('6-pack', '').replace('10-pack', '').replace('3-pack', '').replace('5-pack', '').replace('7-pack', '');
          }
        })
        ele.addEventListener('mouseout', () => {
          let titleEl = this.form.querySelector('[data-color-type] .selected');
          let producttype = ele.closest('[data-color-type]')?.getAttribute('data-color-type')?.replace('U-', '');
          this.form.querySelectorAll('[data-color-name]').forEach((ele) => {
            ele.innerHTML = "";
          })
          if (titleEl?.closest('[data-color-type]') && titleEl?.closest('[data-color-type]') != null && ele.closest('[data-color-type]').querySelector('[data-color-name]') != null) {
            titleEl.closest('[data-color-type]').querySelector('[data-color-name]').innerHTML = titleEl.getAttribute('title').toLowerCase().replaceAll(producttype.toLowerCase(), '').replace('shorts', '').replace('vip', 'VIP').replace('boss 2.0', '').replace('icon 2.0', '').replace('rib tank', '').replace('luxe bralette', '').replace('u-', '').replace('sleep short sleeve tee', '').replace('sleep set long sleeve', '').replace('sleep set short sleeve', '').replace('sleep', '').replace('4-pack', '').replace('6-pack', '').replace('10-pack', '').replace('3-pack', '').replace('5-pack', '').replace('7-pack', '');
          }
        })
      });

      this.products = this.form.querySelectorAll('[data-style-id]');
      this.products.forEach(prouduct => prouduct.addEventListener('click', this._fetchProduct.bind(this)));

      this.packProducts = this.form.querySelectorAll('[data-pack-style]');
      this.packProducts.forEach(packProduct => packProduct.addEventListener('click', this._managePackSelection.bind(this)));

      this.customerDetails = {};
      this.activeSubscriptions = [];
      this.firstUpcomingSubscription = {};
      // Recharge Widget Radio Button Listener
      //   setTimeout(() => {
      //       let firstWidgetEl = this.querySelector('[data-widget-container-wrapper].pdp-widget-ab-test-v1');
      //       let secondWidgetEl = this.querySelector('[data-widget-container-wrapper].pdp-widget-ab-test-v2');
      //       if (firstWidgetEl && secondWidgetEl) {
      //           if (document.querySelector('[pdp-widget-ab-test-v2]')) {
      //               firstWidgetEl.remove();
      //           } else {
      //               firstWidgetEl.style.display = 'block !important';
      //               secondWidgetEl.remove();
      //           }
      //       }
      //   }, 1000);

      this.querySelectorAll('[data-widget-container-wrapper] [type="radio"]').forEach(ele => {
        ele.addEventListener('change', this._manageWidget.bind(this));
      });

      this.querySelectorAll('[data-manage-subscription]').forEach(ele => {
        ele.addEventListener('click',(event)=>{
          let subscriptionInput=ele.querySelector('input');
          if(subscriptionInput.checked){
            this.querySelector('[data-main-subscription]').value=true;
          }else{
            this.querySelector('[data-main-subscription]').value=false;
          }
        })
      });
      this.form.closest('product-form').querySelector('[data-productid] [data-widget-container-wrapper]')?.querySelectorAll("input[type='radio']").forEach((radioButton)=>{
        radioButton.addEventListener("click", (event) => {

          let selector = '.pdp-widget-ab-test-v1';
          if (radioButton.closest('.pdp-widget-ab-test-v2')) {
            selector = '.pdp-widget-ab-test-v2';
          }

          /* ------------ Out of stoke logic ------------ */
          if (this.form.querySelector('.klaviyo-bis-trigger')) {
            return;
          }

          let elements = radioButton.closest('[data-productid]').querySelectorAll(`${selector} .option_onetime`);

          elements.forEach((div) => {
              div.classList.remove('selected');
          });
          if (radioButton.checked) {
              radioButton.parentNode.parentNode.classList.add('selected');
              if (radioButton.id.includes('subscription')) {

                radioButton.closest('[data-productid]').querySelectorAll('[data-normal-button] [data-link-text]').forEach((ele) => {
                  ele.setAttribute('data-link-text', window.customerDetails.id ? 'Add Subscription to box' : 'Add Subscription to bag');
                  ele.setAttribute('data-link-subcategory', window.customerDetails.id ? 'AddToBox' : 'AddToCart');

                });
                this.querySelector('afterpay-placement').classList.add('d-none');
                let freeShipMsg = this.querySelector('[data-free-59-message]');
                if (freeShipMsg) freeShipMsg.innerHTML = 'Free Shipping & Free Returns'
                this.querySelector('[data-shipping-info]').classList.add('mt-3');
                if (this.querySelector('[data-main-subscription]') != null) {
                  this.querySelector('[data-main-subscription]').value="true";
                }
              }
              else if(radioButton.id.includes('add_onetime')){
                // Added By Sayek to set GA4 tag on 04/04/2023
                radioButton.closest('[data-productid]').querySelectorAll('[data-normal-button] [data-link-text]').forEach((ele) => {
                  ele.setAttribute('data-link-text', window.customerDetails.id ? 'Add Subscription to box' : 'Add Subscription to bag');
                  ele.setAttribute('data-link-subcategory', window.customerDetails.id ? 'AddToBox' : 'AddToCart');

                });
                radioButton.closest('[data-productid]')?.querySelector('.faq_section')?.classList.add('d-none');
                this.querySelector('afterpay-placement').classList.add('d-none');
                  let freeShipMsg = this.querySelector('[data-free-59-message]');
                  if (freeShipMsg) freeShipMsg.innerHTML = 'Free Shipping & Free Returns'
                this.querySelector('[data-shipping-info]').classList.add('mt-3');
                if (this.querySelector('[data-main-subscription]') != null) {
                  this.querySelector('[data-main-subscription]').value="true";
                }
              }
              else {
                // Added By Sayek to set GA4 tag on 04/04/2023
                radioButton.closest('[data-productid]').querySelectorAll('[data-normal-button] [data-link-text]').forEach((ele) => {
                  ele.setAttribute('data-link-text', 'Add to bag');
                  ele.setAttribute('data-link-subcategory', 'AddToCart');
                });
                radioButton.closest('[data-productid]')?.querySelector('.faq_section')?.classList.add('d-none');
                this.querySelector('afterpay-placement').classList.remove('d-none');
                  let freeShipMsg = this.querySelector('[data-free-59-message]');
                  if (freeShipMsg) freeShipMsg.innerHTML = 'Free Shipping & Free Returns'
                this.querySelector('[data-shipping-info]').classList.remove('mt-3');
                if (this.querySelector('[data-main-subscription]') != null) {
                  this.querySelector('[data-main-subscription]').value="false";
                }

              }
          }
      });
      })

      this._triggerOOS();
      if (!flag) {
        flag=true
        if (window.customerDetails?.customerTags.toLowerCase().includes('active subscriber') && window.globalVariables?.template == 'product') {
          this._fetchCustomerDetails();
        }
      }
      this.form.querySelector('[data-ship_with_subscription]')?.addEventListener('click', this._shipWithNextSubscription.bind(this));

      this.querySelector('[data-subscribe-checked]')?.addEventListener('change',(event)=>{
        this.querySelector('[data-subscribe-price]').classList.toggle('d-none')
        this.querySelector('[data-original-price]').classList.toggle('original-product-price')
        this.querySelector('[data-discounted-price]').classList.toggle('text-decoration-underline')
        this.querySelector('input[name="properties[_main_subscription]"]').value = event.target.checked;
        this.querySelectorAll('[data-normal-button] [data-link-text]').forEach((ele) => {
          ele.setAttribute('data-link-text', event.target.checked ? 'Add Subscription to bag' : 'Add to bag');
        });
      })

      /*-------------Manage OOS Stock A/b Test-------------*/
      this.querySelector('[data-oos-stock] button')?.addEventListener('click',()=>{
        if(this.productJson?.tags?.includes('FEW_STOCK')){
          VWO.event("labelSwatchJoinWaitlist", {
            "count": 1
          });
        }
      })

      document.querySelectorAll('[data-single-product] .product__img__tags div').forEach((ele)=>{
        if (ele.innerHTML.trim() == "" && ele.closest('.product__img__tags').querySelector('.see-my-size-btn') == null) {
          ele.closest('.product__img__tags').classList.add('d-none');
        }else{
          ele.closest('.product__img__tags').classList.remove('d-none');
        }
      })

      if (document.getElementById("see-my-size-data")) {
        let seeMySizeData=JSON.parse(document.getElementById("see-my-size-data")?.innerHTML?.trim()) || [];
        if (seeMySizeData.length === 0) {
          document.querySelectorAll('.see-my-size-btn').forEach((ele)=>{
            ele.classList.remove('d-none')
          })
        }
      }
      this._openModalOpenerEvents();
      this._removeDummySizes();

    setTimeout(() => {
        document.querySelectorAll('custom-wishlist-button.pd_custom_wl.d-none').forEach(ele => ele.classList.remove('d-none'));
    }, 1500)

      let sizeEle = this.form.querySelectorAll('[name="size"]');
      if (sizeEle.length && sizeEle.length <= 1) {
            this.form?.querySelector('#AddToCart-:not(#AddToCart-.d-none)')?.classList?.remove('disabled');
      }
    }

      document.querySelectorAll('.product-type-toggle').forEach(ele => ele.classList?.remove('disabled'));
  }

  _removeDummySizes() {
      const swatchElements = this.querySelectorAll('[data-unavailable-discount-sizes]');
      const allSizes = new Set();

      swatchElements.forEach(el => {
          const sizeData = el.getAttribute('data-unavailable-discount-sizes');
          if (sizeData) {
              const pairs = sizeData.split(',');
              pairs.forEach(pair => {
                  const size = pair.split('--')[0];
                  if (size) {
                      allSizes.add(size.replace('\n', '').trim());
                  }
              });
          }
      });

      let availableSizes = Array.from(allSizes);
      if (availableSizes.length > 0) {
          const sizeInputs = this.querySelectorAll('.size_value_container .variant-size input[name="size"][data-handle]');

          sizeInputs.forEach(input => {
              const size = input.getAttribute('data-handle')?.toUpperCase();
              const parentLi = input.closest('li.variant-size');

              if (size && parentLi && !allSizes.has(size)) {
                  parentLi.classList.add('d-none');
              }
          });
      }
  }
  _manageWidget(event) {
    let container = event.target.closest('[data-purchaseType]');
    let type = container.getAttribute('data-purchaseType');
    event.target.closest('[data-widget-container-wrapper]')?.querySelector('.option_onetime.selected')?.classList.remove('selected');
    event.target.closest('.option_onetime')?.classList.add('selected');

    this._manageTextDecoration();

    if (type == 'subscription') {
      // change subscription button AB test
      let changeSubscriptionButtonTest = !!document.querySelector('[data-change-subscription-button]');
      this.form.querySelectorAll('[data-customer="loggedin"] button .add-text').forEach(el => {
        el.innerText = changeSubscriptionButtonTest ? "Add to bag" : "Add Subscription to bag"
      });
    let freeShipMsg = this.querySelector('[data-free-59-message]');
    if (freeShipMsg) freeShipMsg.innerHTML = 'Free Shipping & Free Returns'

    }else{
      this.form.querySelectorAll('[data-customer="loggedin"] button .add-text').forEach(el => {
        el.innerText="Add to bag";
      });
    let freeShipMsg = this.querySelector('[data-free-59-message]');
    if (freeShipMsg) freeShipMsg.innerHTML = 'Free Shipping & Free Returns'
    }

    if (type == 'onetime') {
      this.querySelectorAll('upsell-item,square-placement').forEach((ele)=>{
        ele.classList.remove('d-none');
          ele.closest('.rebuy-pdp')?.classList?.remove('d-none');
      })
    }else{
      this.querySelectorAll('upsell-item:not(.rebuy-pdp upsell-item),square-placement').forEach((ele)=>{
        ele.classList.add('d-none');
          ele.closest('.rebuy-pdp')?.classList?.add('d-none');
      })
    }
    // Manage Button
      let freeShipMsgContent = this.querySelector('[data-free-59-message]');
    if (type == 'subscription' || type == 'onetime') {
      this.form.querySelector('[data-customer="non-loggedin"]').classList.add('d-none')
      this.form.querySelector('[data-customer="loggedin"]').classList.remove('d-none');
      if (freeShipMsgContent && window.customerDetails?.id) freeShipMsgContent.innerHTML = 'Free Shipping & Free Returns'
    } else {
      this.form.querySelector('[data-customer="non-loggedin"]').classList.remove('d-none')
      this.form.querySelector('[data-customer="loggedin"]').classList.add('d-none');

      if (freeShipMsgContent && window.customerDetails?.id) freeShipMsgContent.innerHTML = 'Free Shipping & Free Returns'
    }
  }
  _manageTextDecoration=()=>{
    // Manage Price text
    let currentForm=document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('form');
    let type=currentForm?.querySelector('[data-widget-container-wrapper] input:checked')?.closest('[data-purchasetype]')?.getAttribute('data-purchasetype')
    if (type) {
      if (type == 'subscription' || type == 'addon') {
        document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('[data-product-container]')?.querySelector('[data-currentprice]')?.classList.add('text-decoration-line-through');
      } else {
        document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('[data-product-container]')?.querySelector('[data-currentprice]')?.classList.remove('text-decoration-line-through');
      }
    }
  }
  /**
   * Ajax call for fetching product
   * @param {*} event
   */
  async _fetchProduct(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (loading) {
      return;
    }

    loading = true;
    this.addBtn = this.form.querySelector('[name="add"]');
    if (this.addBtn) {
        document.querySelector('[data-new-material]')?.classList.add('pointer-events-none');
        this.addBtn.classList.add('disabled')
        document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.add('disabled')
        setTimeout(() => {
            this.addBtn.classList.remove('disabled')
            document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.remove('disabled')
        }, 5000)
    }
    let selectionType=event.target.closest('[data-product-type]')?.getAttribute('data-product-type');
    let url = event.target.closest(`[data-product-type="${selectionType}"] [data-product-url]`)?.getAttribute('data-product-url');
    window.purchaseType = this.form?.querySelector('[data-purchasetype].selected')?.getAttribute('data-purchasetype') || false;
    this.form.querySelector(`[data-product-type="${selectionType}"] [data-product-url].selected`)?.classList.remove('selected');
    event.target.closest(`[data-product-type] [data-product-url]`)?.classList.add('selected');
    if (event.target.closest(`[data-product-type="pack"]`)?.querySelector('input')) {
      event.target.closest(`[data-product-url]`).querySelector('input').checked = true;
    }
    let template=document.querySelector(`[data-product-url="${url}"].selected`)?.getAttribute('data-product-template');
    history.replaceState(null, null, `${window.location.origin}${url}${template ? '?view=limited-core' : ''}`);

    let actionButton = event.target;
    if (actionButton.closest('.product-type-toggle')) {
        actionButton.closest('.product-type-toggle')?.classList?.add('disabled');
    }
    this.updateProductInfo(url);
  }

  updateProductInfo(url) {

      // document.querySelector('[data-color-swatch]')?.classList.add('pointer-events-none');
      // Fetch and process swatch data
      if (!allProductJson[url]) {
        allProductJson[url] = {
          imageJson: null,
          formHtml: null,
          relatedHtml: null,
          sameColorHtml: null
        };
      }
      let imageJson = allProductJson[url]['imageJson'];
      if (!imageJson) {
        fetch(`${url}?view=swath.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to fetch swatch data");
                }
                return response.json();
            })
            .then(data => {
                allProductJson[url]['imageJson'] = data;
                this._manageVIPBlur(data);
                this._generateHtml(data);
            })
            .catch(error => {
                console.error("An error occurred with swatch data:", error);
                loading = false;
                if (this.addBtn) this.addBtn.classList.remove('disabled')
                document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.remove('disabled')
            });
      }else{
        this._manageVIPBlur(imageJson);
        this._generateHtml(imageJson);
      }

      let formHtml = allProductJson[url]['formHtml'];
      let sameColorHtml = allProductJson[url]['sameColorHtml'];
      let relatedDomHtml = allProductJson[url]['relatedHtml'];

      if (!formHtml) {
        // Fetch and process section data
        const sectionID = this.closest('[data-section-id]').getAttribute('data-section-id');
        const colorSectionID = this.closest('main.content-for-layout')?.querySelector('[data-same-color-section-id]')?.getAttribute('data-same-color-section-id');
        fetch(`${url}?sections=${sectionID},${colorSectionID}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to fetch section data");
                }
                return response.json();
            })
            .then(data => {
                const html = data[sectionID];
                const sameColorHtml = data[colorSectionID];
                const parser = new DOMParser();
                const dom = parser.parseFromString(html, "text/html");
                allProductJson[url]['formHtml'] = dom;

                _replaceFormHtml(dom);
                if (typeof sameColorHtml !== 'undefined' && sameColorHtml) {
                    const sameColorDom = parser.parseFromString(sameColorHtml, "text/html");
                    allProductJson[url]['sameColorHtml'] = sameColorDom;
                    if (document.querySelector('#same_color_product_container')) {
                        document.querySelector('#same_color_product_container').innerHTML = sameColorDom?.querySelector(`#same_color_product_container`)?.innerHTML;
                    }
                    const sameColorProductsWrapper = document.querySelector(
                        ".section-same-color-products"
                    );
                    const sameColorProdPrevBtn = sameColorProductsWrapper?.querySelector(
                        ".slider-nav-btn[data-prev-button]"
                    );
                    const sameColorProdNextBtn = sameColorProductsWrapper?.querySelector(
                        ".slider-nav-btn[data-next-button]"
                    );

                    sameColorProdPrevBtn?.addEventListener("click", () => {
                        sameColorProductsWrapper.querySelector(".swiper-button-prev").click();
                    });

                    sameColorProdNextBtn?.addEventListener("click", () => {
                        sameColorProductsWrapper.querySelector(".swiper-button-next").click();
                    });
                }

                _getRelatedProducts(relatedDomHtml, url);
            })
            .catch(error => {
                console.error("An error occurred with section data:", error);
                loading = false;
                if (this.addBtn) this.addBtn.classList.remove('disabled')
                document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.remove('disabled')
            });
      }else{
        _replaceFormHtml(formHtml);
          _getRelatedProducts(relatedDomHtml, url);
        if (document.querySelector('#same_color_product_container')) {
            document.querySelector('#same_color_product_container').innerHTML = sameColorHtml;
        }
      }
  }

  _managePackSelection(event){
    event.stopImmediatePropagation();

    let currentForm=document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('form');
    currentForm?.querySelector('li .selected')?.classList.remove('selected');
    event.target.closest('[data-pack-style]')?.classList.add('selected')
  }

  _manageVIPBlur(data) {
    if (data && data.tags?.length > 0) {
      const productHandle = data.handle
      let settings = window.globalVariables.settings;
      if (settings && data.tags.includes(settings['vip_product_tag'] ?? 'VIP_PRODUCT')) {
        const activeSubscriber = window.customerDetails?.customerTags.toLowerCase().includes('active subscriber');
        if (!activeSubscriber) {
          let loginModalElement = document.querySelector('[data-vip-blur-login-modal] .modal');
          if (loginModalElement) {
            loginModalElement.classList.add('open')
            loginModalElement.classList.remove('opacity-0')
            document.body.style.overflow = 'hidden';

            let redirectElement = loginModalElement.querySelector('#vip-blur-login-modal-redirect');
            if (redirectElement) {
              redirectElement.setAttribute('value', '/products/' + productHandle)
            }
          }
        }
      }
    }
  }

  _generateHtml(product){
    this._generateSlider(product);
    this._generateProductDetails(product);
    const resizeEvent = new Event('resize', {
      bubbles: true,
      cancelable: true,
    });
    window.dispatchEvent(resizeEvent);
  }
  _generateSlider(product, bundle = false){
    document.querySelector('[data-product-container]')?.setAttribute('data-product-container',product.id)
    let media = [...product.media];

    if (media.length > 1 && !product.tags.includes('PACK')) {
      media.splice(-1, 1);
    }

    let images= media;
    let imagesHtml= ``;

    images.forEach((img, imgIndex)=>{
      if (img.src.includes('vertical_')) return;

      let imageTags = img.alt?.split(',')
      let imageTagHtml = "";
      let isFabric = false;

      if (imageTags && imageTags.length) {
        imageTagHtml = imageTags
          .filter(imageTag => (imageTag !== undefined && imageTag !== null && imageTag !== "material_image"))
          .map(imageTag => `<span class="product__img__tag">${imageTag}</span>`).join('');

        let tempHtml = "";
        imageTags.forEach(imageTag => {
          if (imageTag === "material_image" && imageTag !== undefined && imageTag !== null ) {
            isFabric = true;
            imageTagHtml = tempHtml + `
              <span class="pdp-material-ab-test-v1">
                <span class="product__img__tags image__tag__exist prev_see_in_my_size">
                  <button class="see-my-size-btn"  data-trigger-seemysize="{{ product.type | downcase }}">See it in my size</button>
                </span>
              </span>
              <span class="pdp-material-ab-test-v2">
                <span class="product__img__tags image__tag__exist fabric_tag text-uppercase cursor-pointer" data-modal-opener="fabric-material-popup">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 28 28" style="enable-background:new 0 0 28 28; width: 16px" xml:space="preserve">
                      <g><g>
                        <path d="M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13S20.2,26,13,26z M13,2C6.9,2,2,6.9,2,13s4.9,11,11,11s11-4.9,11-11
                                S19.1,2,13,2z"/></g></g>
                        <path class="st0" d="M11.8,18.9h2.4v-7.1h-2.4V18.9L11.8,18.9z M11.8,9.5h2.4V7.1h-2.4V9.5L11.8,9.5z"/>
                  </svg>
                  <span class="text-decoration-underline">About this fabric</span>
                </span>
              </span>
            `;
          }
        });
        if (document.querySelector('[data-alt-tags-wrapper]')) {
          let altHtml = '';
          let tagsArray = imageTags?.filter(tag => (tag !== undefined && tag !== null && tag !== 'null'));
          tagsArray.forEach((tag, i) => {
            altHtml += `<span class="product__img__tag ${i > 1 ? 'd-none' : ''}" data-hidden-on-swiper-change="">${tag}</span>`;
          })
          if (!tagsArray.length) {
            document.querySelector('[data-alt-tags-wrapper]').classList.remove('image__tag__exist')
          } else {
            document.querySelector('[data-alt-tags-wrapper]').classList.add('image__tag__exist')
          }
          document.querySelector('[data-alt-tags-wrapper]').innerHTML = altHtml;
        }
      }

      let seeMySizeData=null;
      if(document.getElementById("see-my-size-data")) {
        seeMySizeData = document.querySelector(`[data-see-my-size="${product.type.toLowerCase()}"]`)?.innerHTML?.trim();
        if (seeMySizeData === undefined || seeMySizeData == null) {
          seeMySizeData = document.getElementById("see-my-size-data")?.innerHTML.trim() || [];
        }
      }

      let isPackProductPage = bundle ? false : this?.closest('[data-pack-product]');
      let tempHtml= '';

      if (img.media_type === 'image') {
        tempHtml = `
          <div class="d-flex align-items-center product--media col-6 position-relative" data-mediaid="${img.id}" role="treeitem">
            <img
              src="${img.src}"
              alt="${product.title}" 
              width="2048" height="2048"
            />
            ${
              isFabric
                ? `${imageTagHtml}`
                : `<span class="product__img__tags ${imageTagHtml || isPackProductPage || seeMySizeData ? 'image__tag__exist' : ''} ${product.type == 'mix_pack' ? 'd-none' : ''}">
                    <div>
                      ${imageTagHtml}
                    </div>
                    <button class="see-my-size-btn ${seeMySizeData ? '' : 'd-none'}" data-trigger-seemysize="${product.type.toLowerCase().replace('baller_padliner', 'baller').replace('baller high waisted', 'baller-high-waisted').replace('biker high waisted', 'biker-high-waisted').replace('star flex', 'star').replace('baller flex', 'baller').replace('ballerhighwaisted_pack', 'baller-high-waisted').replace('bikerhighwaisted_pack', 'biker-high-waisted').replace('ballerpadliner_pack', 'baller').replace('starflex_pack', 'star').replace('ballerflex_pack', 'baller').replace('ballerwim_pack', 'baller').replaceAll('_pack', '')}">See it in my size</button>
                  </span>
                  ${
                    imgIndex === 0 && window.globalVariables?.settings?.wishlist_setting_enabled
                      ? `<div class="custom-epi-pdp-btn">
                          <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${product.id}"
                            data-swaction="addToWishlist" data-product-id="${product.id}" data-variant-id="${product?.variants[0]?.id}"
                            data-product-url="https://woxer.com/products/${product.handle}">
                          </button>
                        </div>`
                      : ``
                  }`
            }
          </div>
        `;
      }

      if (img.media_type === 'video') {
        tempHtml=`
          <div class="d-flex align-items-center product--media col-6 position-relative"data-mediaID="${img.id}" role="treeitem">
            <video-media>
              <div class="product-video-wrapper position-relative d-flex justify-content-center align-items-center" data-custom-video>
                <div class="position-relative d-flex justify-content-center align-items-center">
                  <video playsinline loop src="${img?.sources?.[0]?.url}" muted class="product-media-video desktop-video w-100"></video>
                  <div data-play-icon class="video-playing-btn">
                    <svg viewBox="0 0 55 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M40.6641 25.9012L21.3486 39.1917L21.3486 12.6107L40.6641 25.9012Z" fill="#44434B"/>
                      <path d="M53.3965 26.5498C53.3965 40.2764 41.832 51.498 27.4482 51.498C13.0645 51.498 1.5 40.2764 1.5 26.5498C1.5 12.8233 13.0645 1.60156 27.4482 1.60156C41.832 1.60156 53.3965 12.8233 53.3965 26.5498Z" stroke="#44434B" stroke-width="3"/>
                    </svg>
                  </div>
                  <div data-pause-icon class="video-playing-btn d-none">
                    <svg width="55" height="53" viewBox="0 0 55 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M53.3965 26.4482C53.3965 40.1748 41.832 51.3965 27.4482 51.3965C13.0645 51.3965 1.5 40.1748 1.5 26.4482C1.5 12.7217 13.0645 1.5 27.4482 1.5C41.832 1.5 53.3965 12.7217 53.3965 26.4482Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                    </svg>
                  </div>
                </div>
              </div>
            </video-media>
          </div>
      `;
      }

      imagesHtml+=tempHtml;
    });

    let productContainer = bundle
      ? document.querySelector('[data-product-container]')
      : this.closest('[data-product-container]');

    if (!productContainer) {
      productContainer = document.querySelector('[data-product-container]');
    }

    if (productContainer && productContainer.querySelector('[data-desktop-product-slider]') != null) {
      productContainer.querySelector('[data-desktop-product-slider]').innerHTML=imagesHtml;
      document.dispatchEvent(new CustomEvent("swym:product-loaded"));
      // setTimeout(() => {
      //     productContainer.querySelectorAll('custom-wishlist-button.pd_custom_wl.d-none').forEach(ele => ele.classList.remove('d-none'));
      // }, 500)
    }

    imagesHtml="";
    images.forEach((img)=>{
      if (img.src.includes('vertical_')) return;

      let imageTags = img.alt?.split(',');
      if (imageTags && imageTags.length) {
        if (document.querySelector('[data-alt-tags-wrapper]')) {
          let altHtml = '';
          let tagsArray = imageTags?.filter(tag => (tag !== undefined && tag !== null && tag !== 'null'));
          let isTagAvailable = false;
          tagsArray.forEach((tag, i) => {
            if (tag.replace('material_image', '')) isTagAvailable = true;
              altHtml += `<span class="product__img__tag ${i > 1 ? 'd-none' : ''}" data-hidden-on-swiper-change>${tag.replace('material_image', '')}</span>`;
            })

            if (!tagsArray.length) {
              document.querySelector('[data-alt-tags-wrapper]').classList.remove('image__tag__exist')
            } else {
              document.querySelector('[data-alt-tags-wrapper]').classList.add('image__tag__exist')
            }
            if (isTagAvailable) document.querySelector('[data-alt-tags-wrapper]').innerHTML = altHtml;
          }
      }
      let tempMobileHtml= "";
      if (img.media_type === 'image') {
        tempMobileHtml =`
          <div class="swiper-slide d-flex align-items-center product--media col-6 swiper-slide-active" data-alt-tags="${img.alt || ''}" data-mediaid="${img.id}" role="treeitem" style="width: 375px; margin-right: 10px;">
            <img
            src="${img.src}"
            data-variant-title="${product.title}"
            alt="${product.title}"
            width="2048" height="2048"/>
          </div>
        `;
      }

      if (img.media_type === 'video') {
        tempMobileHtml =`
          <div class="swiper-slide d-flex align-items-center product--media col-6" data-mediaID="${img.id}" role="treeitem">
            <video-media>
              <div class="product-video-wrapper position-relative d-flex justify-content-center align-items-center" data-custom-video>
                <div class="position-relative d-flex justify-content-center align-items-center product-mobile-media-video">
                  <video playsinline loop src="${img?.sources?.[0]?.url}" muted class="product-media-video mobile-video w-100"></video>
                  <div data-play-icon class="video-playing-btn">
                    <svg viewBox="0 0 55 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M40.6641 25.9012L21.3486 39.1917L21.3486 12.6107L40.6641 25.9012Z" fill="#44434B"/>
                      <path d="M53.3965 26.5498C53.3965 40.2764 41.832 51.498 27.4482 51.498C13.0645 51.498 1.5 40.2764 1.5 26.5498C1.5 12.8233 13.0645 1.60156 27.4482 1.60156C41.832 1.60156 53.3965 12.8233 53.3965 26.5498Z" stroke="#44434B" stroke-width="3"/>
                    </svg>
                  </div>
                  <div data-pause-icon class="video-playing-btn d-none">
                    <svg width="55" height="53" viewBox="0 0 55 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M53.3965 26.4482C53.3965 40.1748 41.832 51.3965 27.4482 51.3965C13.0645 51.3965 1.5 40.1748 1.5 26.4482C1.5 12.7217 13.0645 1.5 27.4482 1.5C41.832 1.5 53.3965 12.7217 53.3965 26.4482Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M21 16C21 24.201 21 28.799 21 37L21 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                      <path d="M32.5 16C32.5 24.201 32.5 28.799 32.5 37L32.5 16Z" stroke="#44434B" stroke-width="3"/>
                    </svg>
                  </div>
                </div>
              </div>
            </video-media>
          </div>
        `;
      }

      // Image preloading logic
      const imgElement = document.querySelector('.card-img img');
      if (imgElement && imgElement.src !== img.src) {
        const preloadedImg = new window.Image();
        preloadedImg.src = img.src;
        preloadedImg.onload = () => {
          imgElement.src = img.src;
        };
      }

      imagesHtml+=tempMobileHtml;
    });

    productContainer?.querySelectorAll('.custom-epi-pdp-btn.mobile_pdp_wl').forEach(ele => {
      let wlBtn = ele.querySelector('[data-with-epi]')
      if (!wlBtn) return;

      wlBtn.setAttribute('data-product-id', product.id);
      wlBtn.setAttribute('data-variant-id', product?.variants[0]?.id);
      wlBtn.setAttribute('data-product-url', `https://woxer.com/products/${product.handle}`);
      const dynamicClass = Array.from(wlBtn.classList).find(c => c.startsWith('product_'));

      if (dynamicClass) {
        wlBtn.classList.remove(dynamicClass);
        wlBtn.classList.add(`product_${product.id}`);
      }
    });

    let mobileSliders = productContainer?.querySelectorAll('[data-mobile-product-slider] .swiper-wrapper')
    mobileSliders?.forEach((ele)=>{
      let isNewSlider = ele.querySelector('.new-swiper-slide');
      ele.innerHTML = imagesHtml
      if (isNewSlider) {
        ele.querySelectorAll('.swiper-slide').forEach((slider)=>{
          slider?.classList.add('new-swiper-slide')
        })
      }
    })

    document.dispatchEvent(new CustomEvent("swym:product-loaded"));
      // setTimeout(() => {
      //     productContainer.querySelectorAll('custom-wishlist-button.pd_custom_wl.d-none').forEach(ele => ele.classList.remove('d-none'));
      // }, 500)
    const seeMySizeButtons = document.querySelectorAll(".see-my-size-btn");
    document.querySelectorAll('[data-trigger-seemysize]').forEach((ele)=>{
      ele.setAttribute('data-trigger-seemysize', product.type.toLowerCase().replace('baller_padliner', 'baller').replace('baller high waisted', 'baller-high-waisted').replace('biker high waisted', 'biker-high-waisted').replace('star flex', 'star').replace('baller flex', 'baller').replace('ballerhighwaisted_pack', 'baller-high-waisted').replace('bikerhighwaisted_pack', 'biker-high-waisted').replace('ballerpadliner_pack', 'baller').replace('starflex_pack', 'star').replace('ballerflex_pack', 'baller').replace('ballerwim_pack', 'baller').replaceAll('_pack', ''))
    })
    const seeMySizeData = document.getElementById("see-my-size-data")?.innerHTML.trim();

    document.querySelectorAll('[data-modal-opener="fabric-material-popup"]').forEach((ele)=>{
      ele.addEventListener('click',()=>{
        document.querySelector('#fabric-material-popup')?.show();
      })
    })
    if (seeMySizeButtons && seeMySizeData) {
      seeMySizeButtons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.stopImmediatePropagation();
          let type = event.target.closest('[data-trigger-seemysize]').getAttribute('data-trigger-seemysize');
          const seeMySizeData = document.querySelector(`[data-see-my-size="${type.toLowerCase().replaceAll('_pack', '')}"]`)?.innerHTML.trim();
          const seeMySizeModal = document.createElement("see-my-size");
          seeMySizeModal.dataset.seeMySizeData = seeMySizeData;
          document.querySelector("body").prepend(seeMySizeModal);
            let container = event.target.closest("[data-selected-product-size]");
            if (container) {
                seeMySizeModal.dataset.selectedSize = container.getAttribute('data-selected-product-size').trim();
            }
          document.querySelector('body').classList.add('position-fixed-mobile');
          document.body.style.overflowY = "hidden";
          Utils.openOverlay();
        });
      });
    }
  }
  _generateProductDetails(product){
    this.productContainer = this.closest('[data-product-container]');
    this.productContainer?.querySelectorAll('[data-product_title]').forEach((ele)=>{
      if (product?.title) {
        ele.innerHTML=product?.title
      }
    })
    this.avoid_product_details_tags = this.productContainer?.querySelector('[data-avoid_product_tags]')?.getAttribute('data-avoid_product_tags').split(',');
    this.is_contain_exlcude_product_detail_tag = this.avoid_product_details_tags?.some(tag => product.tags.includes(tag.replaceAll('\n','')));
    this.productContainer?.querySelectorAll(`[data-product_description][data-custom-description="false"]`)?.forEach((ele)=>{
      ele.innerHTML=product.description;
    });

    this.productContainer?.querySelectorAll('[data-product_description][data-custom-description]')?.forEach((ele)=>{
      if (this.is_contain_exlcude_product_detail_tag || product.type.toLowerCase().includes('mix_pack')) {
        if (ele.getAttribute('data-custom-description') == "false") {
          ele.classList.remove("d-none")
        }
        if (ele.getAttribute('data-custom-description') == "true") {
          ele.classList.add("d-none")
        }
      }
      if (!this.is_contain_exlcude_product_detail_tag && !product.type.toLowerCase().includes('mix_pack')) {
        if (ele.getAttribute('data-custom-description') == "true") {
          ele.classList.remove("d-none")
        }
        if (ele.getAttribute('data-custom-description') == "false") {
          ele.classList.add("d-none")
        }
      }
    });

    this.setVideoAttribute();

    const okeBtn = document.querySelector('[data-oke-widget] .oke-w-writeReview.oke-button');
    if (okeBtn) {
        const okeNewProductId = 'shopify-' + product?.id;
        const okeUrl = new URL(okeBtn.href);
        okeUrl.searchParams.set('productId', okeNewProductId);
        okeBtn.href = okeUrl.toString();
    }
  }
  setVideoAttribute() {
    setTimeout(() => {
      document?.querySelectorAll(".product-images-wrapper [data-mobile-product-slider] .swiper-slide")?.forEach((slide, index) => {
        const includesVideo = slide.querySelector("video-media");
        if (includesVideo) {
          document.querySelectorAll("video-media-btn .swiper-pagination .swiper-pagination-bullet")?.forEach((bullet, bulletIndex) => {

            if (index == (bulletIndex) && !bullet.classList.contains("video-icon")) {
              bullet.classList.add("video-icon");
            }
          });
        }
      });
      document?.querySelector('[data-product-media] [data-product-play-icon]')?.classList.remove('d-none');
      document?.querySelector('[data-product-media] [data-product-pause-icon]')?.classList.add('d-none');
    },1000);
  }
  async _fetchCustomerDetails() {
      await rechargeSdk._authCustomer();
    await rechargeSdk?._getCustomerDetails();
    this.customerDetails = window.customerDetails.rechargeCustomerDetails;
    await this._fetchSubscriptions();
  }
  async _fetchSubscriptions() {
    //Get Subscriptions
    await rechargeSdk?._getSubscriptions();
  }

  async _shipWithNextSubscription(event) {
    let eligibleAddToCart = this._hideShowSubmitBtnError();
    if (!eligibleAddToCart) {
      return false;
    }
    let price = parseFloat(this.form.querySelector('[data-purchasetype="addon"] [data-addon_price]').getAttribute('data-addon_price')) / 100;
    let variantId = this.form.querySelector('[name="id"]').value;
    event.target.closest('.btn').classList.add('loading');
    if (window.customerDetails.rechargeSubscriptions == null) {
      await this._fetchCustomerDetails();
    }
    let activeSubscriptions = window.customerDetails.rechargeSubscriptions;
    var addonObj = {
      address_id: activeSubscriptions[0]?.address_id,
      next_charge_scheduled_at: activeSubscriptions[0]?.next_charge_scheduled_at,
      price: price,
      presentment_currency: window.customerDetails.rechargeCustomerDetails?.include?.addresses[0]?.presentment_currency,
      external_variant_id:{
        ecommerce: variantId.toString()
      },
      quantity: 1
    }

    let response = null;
    response = await commonAPI._createOnetimeAddon(addonObj);
    if (response) {
      event.target.closest('.btn').classList.remove('loading');
      document.querySelector('#successPopup-addon').show()
    } else {
      event.target.closest('.btn').classList.remove('loading');
    }
  }
  /**
   * Product Form Submit event
   */
  onSubmitHandler(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      const addItems = [];
      const submitButton = this.querySelectorAll('[type="submit"]');
      const qtyInput = this.querySelector('[data-qty-input]');

      let eligibleAddToCart = this._hideShowSubmitBtnError();
      if (!eligibleAddToCart) {
          return false;
      } else {
          submitButton.forEach((ele) => {
              ele.setAttribute('disabled', true);
              ele.classList.add('loading');
          })
          const packBuilder = document.querySelector('sticky-pdp-pack-builder');
          packBuilder?.querySelector('[data-sticky-pdp-builder-atc]').classList.add('loading');
          const offerMarker = document.querySelector('.offer_ab_test');

          let formItem = JSON.parse(serializeForm(this.form));
          if (offerMarker) {
              formItem.properties = formItem.properties || {};
              formItem.properties['_offer_line_item'] = true;
          }
          addItems.push(formItem);
          if (this.upsellItems.length) {
              let isSubscriptionProduct = this.querySelector('[data-selling_plan="null"] input')?.checked;
              if (isSubscriptionProduct) {
                  this.upsellItems.forEach((upsellItem) => {
                      let upsellItemsEle = upsellItem.querySelector('[data-upsell-selection]:checked');
                      if (upsellItemsEle && upsellItemsEle.value != "") {
                          let upsellItemJSON = {
                              id: upsellItemsEle.value,
                              properties: {
                                  "_upsell": "true"
                              }
                          }
                          addItems.push(upsellItemJSON);
                      }
                  });
              }
          }
          if (this.productJson?.tags?.includes('FEW_STOCK')) {
              VWO.event("labelSwatchAddToCart", {
                  "count": 1
              });
          }

          try {
              var bundleItem = {};
              if (evt.target.closest('[data-pack-bundle-form]')) {
                  let isMixPackProduct = this.form.closest('[data-style-image].mix_pack') != null ? true : false;
                  let selectedSize = document.querySelector('[data-selected-product-size]')?.getAttribute('data-selected-product-size');
                  let packVariantId = document.querySelector('[name="id"]')?.value;
                  let packProductId = document.querySelector('form[data-productid]')?.getAttribute('data-productid');
                  let timeStamp = new Date().getTime();
                  const bundlePackScript = document.querySelector('script[data-bundle-componentJson]');
                  const components = JSON.parse(bundlePackScript.innerHTML);

                  bundleItem = {
                      id: packVariantId,
                      properties: {}
                  };
                  let bundleProperties = "";
                  let bundleSize = 0;

                  let componentLength = components.length;

                  if (isMixPackProduct) {
                      let selectedBottomSize = document.querySelector('[data-selected-bottom-size]')?.getAttribute('data-selected-bottom-size');
                      let selectedTopSize = document.querySelector('[data-selected-top-size]')?.getAttribute('data-selected-top-size');

                      components.forEach((component, componentIndex) => {
                          const matchingVariant = component.variants.find(v => {
                             return (component.type === 'bottom' && v.option.toLowerCase() === selectedBottomSize.toLowerCase())
                              || (component.type === 'top' && v.option.toLowerCase() === selectedTopSize.toLowerCase())
                          });
                          const variantId = matchingVariant?.id;

                          if (variantId) {
                              bundleSize += parseInt(component.quantity || 1);
                              bundleProperties += `${variantId}:${component.quantity || 1}${componentLength -1 !== componentIndex ? '||' : ''}`;
                          } else {
                              console.warn(`No matching variant for size "${selectedSize}" in product ${component.product_id}`);
                          }
                      });
                  } else {
                      components.forEach((component, componentIndex) => {
                          const matchingVariant = component.variants.find(v => v.option === selectedSize);
                          const variantId = matchingVariant?.id;

                          if (variantId) {
                              bundleSize += parseInt(component.quantity || 1);
                              bundleProperties += `${variantId}:${component.quantity || 1}${componentLength -1 !== componentIndex ? '||' : ''}`;
                          } else {
                              console.warn(`No matching variant for size "${selectedSize}" in product ${component.product_id}`);
                          }
                      });
                  }


                  if (bundleProperties) {
                      bundleItem.properties['_components'] = bundleProperties;
                      bundleItem.properties['_bundle_size'] = bundleSize;
                      bundleItem.properties['_bundle_product_id'] = packProductId;
                  } else {
                      bundleItem.properties['_from_pack_bundle'] = true;
                  }
                  if (offerMarker) {
                      bundleItem.properties['_offer_line_item'] = true;
                  }
              }
          } catch (e) {
              console.log(e)
          }

          const body = JSON.stringify({
              items: evt.target.closest('[data-pack-bundle-form]') ? [bundleItem] : addItems
          });

          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
              .then((response) => response.json())
              .then(() => {

                  try {


                      window.VWO = window.VWO || [];
                      VWO.event = VWO.event || function () {
                          VWO.push(["event"].concat([].slice.call(arguments)))
                      };

                      VWO.event("customAddToCart", {
                          cart: 1
                      });

                      if (formItem && formItem.selling_plan) {
                          VWO.event("customAddSubscriptionToCart", {
                              cart: 1
                          });
                      }
                      _triggerAttentiveEvent('add-to-cart')

                  } catch (e) {
                      console.error(e);
                  }

                  if (document.querySelector('#PopupModal-quickshop')) {
                      document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
                  }
                  if (qtyInput) qtyInput.value = 1;
              })
              .catch((e) => {
                  console.error(e);
              })
              .finally(() => {
                  // Close Quick View
                  this.form?.closest('[data-quick_buy]')?.classList.add('d-hide');
                  document.querySelector('body')?.classList.remove('mobile-overflow-none');

                  // Stop loading
                  submitButton.forEach((ele) => {
                      ele.removeAttribute('disabled');
                      ele.classList.remove('loading');
                  })
                  packBuilder?.querySelector('[data-sticky-pdp-builder-atc]').classList.remove('loading');
              });
      }
  }
  _hideShowSubmitBtnError=()=>{
    const submitButton = this.querySelectorAll('[type="submit"]');
    const shipBtn = this.querySelectorAll('[type="button"][name="addon"]')
    this.upsellItems = this.querySelectorAll('upsell-item');
    let selectSizeText = "Please select size";
    const addToBagText = "Add to bag";
    const shipToBoxText = "Add to subscription box";

    let mixPack=this.classList.contains('mix_pack');
    if (mixPack) {
      if (this.querySelectorAll('.swatch [type="radio"]:checked').length == 1) {
        selectSizeText='Please select sizes'
      }
      if (this.querySelectorAll('.swatch [type="radio"]:checked').length == 2) {
        if (this.querySelector('[name="bottom size"]:checked')) {
          selectSizeText='please select top size'
        }else{
          selectSizeText='please select bottom size'
        }
      }
    }
    let isInputBlank = this.querySelector('[name="id"]')?.value != "" ? false : true;
    if (this.upsellItems.length) {
      this.upsellItems.forEach((item)=>{
        let enabledUpsellItem = item.querySelector('[data-upsell-selection]:checked');
        let isSubscriptionProduct = this.querySelector('[data-selling_plan="null"] input')?.checked;
        if (enabledUpsellItem && isSubscriptionProduct && enabledUpsellItem.value == "") {
          isInputBlank = true;
        }
      })
    }
    let submitButtonText = submitButton[0]?.querySelector('.add-text').innerHTML || addToBagText;
    let shipButtonText = shipBtn[0]?.querySelector('.add-text').innerHTML || shipToBoxText;

    if (isInputBlank) {
      submitButton.forEach((ele)=>{
        ele.classList.add('notselected');
        if (ele.querySelector('.add-text')) {
            let btnText = selectSizeText;
            if (ele.closest('[data-pd-type="gift-cards"]')) {
                btnText = 'Please select amount'
            }
          ele.querySelector('.add-text').innerHTML = btnText;
        }else{
          ele.innerHTML = selectSizeText;
        }
      });
      shipBtn.forEach((ele)=>{
        ele.classList.add('notselected');
        if (ele.querySelector('.add-text')) {
          ele.querySelector('.add-text').innerHTML = selectSizeText;
        }else{
          ele.innerHTML = selectSizeText;
        }
      })

      setTimeout(async () => {
        submitButton.forEach((ele)=>{
          ele?.classList.remove('notselected');
          if (ele.querySelector('.add-text')) {
            ele.querySelector('.add-text').innerHTML = submitButtonText;
          }else{
            ele.innerHTML = submitButtonText;
          }
        });


        shipBtn.forEach((ele)=>{
          ele.classList.remove('notselected');
          if (ele.querySelector('.add-text')) {
            ele.querySelector('.add-text').innerHTML = shipButtonText;
          }else{
            ele.innerHTML = shipButtonText;
          }
        })
      }, 1000);
      return false;
    }else{
      return true;
    }
  }

  /**
   * Product Form Quantity Input update action
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }

  _triggerOOS=()=>{
    let oosBtn=this.querySelector('[data-trigger-oos]');
    oosBtn?.addEventListener('click',async (event)=>{
      let id=event.target.closest('[data-oos-modal]').querySelector('select').value;
      let email=event.target.closest('[data-oos-modal]').querySelector('#oos_email').value;
      let newsletter=event.target.closest('[data-oos-modal]').querySelector('#subscribe_newsletter');

      if (email == "") {
        alert('Please enter email');
        return false;
      }
      event.target.closest('.btn')?.classList.add('loading');
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": email,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${id}`
              }
            }
          }
        }
      }

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload),
      };

      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=QKSqUM",requestOptions)
      .then(result => {
        const data = result.json();
        this.querySelector('[data-success-oos-msg]')?.classList.remove('d-none');
        this.querySelector('[data-oos-content]')?.classList.add('d-none');
        this.querySelector('[subscribe_newsletter_container]')?.classList.add('d-none');
        this.querySelector('[data-trigger-oos]').classList.add('d-none');
        this.querySelector('[data-continue-btn]')?.classList.remove('d-none');
        event.target.closest('.btn')?.classList.remove('loading');
      })
      .catch(error => {
        console.log(error,'error');
        event.target.closest('.btn')?.classList.remove('loading');
      });
    })
  }

  _openModalOpenerEvents(){
    this.querySelectorAll('[data-modal-opener]').forEach((ele)=>{
      ele.addEventListener('click',(event)=>{
        event.stopImmediatePropagation();
        let id=ele.getAttribute('data-modal-opener');
        document.querySelector(`#${id}`)?.show(ele);
      })
    })
  }

   _hasDisplayNoneProp(element) {
        const style = window.getComputedStyle(element);
        if (style.display === 'none') {
            return true;
        }

        return false;
    }
    handlePdpImageSlider() {
        const pdSliderWrapper = document.querySelector(".swiper-wrapper.pd_mob_swiper");
        const pdSlides = document.querySelectorAll(".swiper-wrapper.pd_mob_swiper .swiper-slide");

        pdSliderWrapper?.addEventListener("scroll", (event) => {
            let maxVisibleWidth = 0;
            let mostVisibleSlide = null;

            pdSlides.forEach((slide) => {
                const slideRect = slide.getBoundingClientRect();
                const wrapperRect = pdSliderWrapper.getBoundingClientRect();
                let visibleWidth = Math.min(slideRect.right, wrapperRect.right) - Math.max(slideRect.left, wrapperRect.left);

                if (visibleWidth > maxVisibleWidth) {
                    maxVisibleWidth = visibleWidth;
                    mostVisibleSlide = slide;
                }
            });
            if (mostVisibleSlide) {
                    this.updateTags(mostVisibleSlide);
            }
        });
        pdSliderWrapper?.scrollBy({ left: 1, behavior: 'smooth' });
        setTimeout(() => {
            pdSliderWrapper?.scrollBy({ left: -1, behavior: 'smooth' });
        }, 100)
    }
    updateTags(slide = null) {
        if (document.querySelector('[data-alt-tags-wrapper]')) {
            let altHtml = '';
            let activeSlide = slide;
            let tags = activeSlide?.getAttribute('data-alt-tags') || document.querySelector('[data-mobile-product-slider] [data-alt-tags]')?.getAttribute('data-alt-tags');
            let tagsArray = tags?.split(',')?.filter(tag => (tag !== undefined && tag !== null && tag !== 'null'));

            tagsArray?.forEach((tag, i) => {
                altHtml += `<span class="product__img__tag ${i > 1 ? 'd-none' : ''}" data-hidden-on-swiper-change="">${tag.replace(/^\s+|\s+$/g, '').trim()}</span>`;
            })

            document.querySelector('[data-alt-tags-wrapper]').innerHTML = altHtml;

            if (tags == 'material_image') {
                document.querySelector('[data-alt-tags-wrapper]').classList.add('d-none');
                document.querySelector('[data-fabric-mobile-button]')?.classList.remove('d-none');
                document.querySelector('[data-see-my-mobile-button]')?.classList.add('d-none');
            } else {
                document.querySelector('[data-fabric-mobile-button]')?.classList.add('d-none');
                document.querySelector('[data-see-my-mobile-button]')?.classList.remove('d-none');
                document.querySelector('[data-alt-tags-wrapper]').classList.remove('d-none');
            }
        }
    }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.isMixPackProduct = this.form.closest('[data-style-image].mix_pack') != null ? true : false;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');

    let productId = this.form.dataset?.productId;
    this.productJson = productId ? JSON.parse(this.form?.querySelector(`script.productJSON-${productId}`)?.innerText) : {};
    this.productJson = this.productJson.product || {};

    this.variantPicker = this.dataset.type;
    this.isNewBundlePack = this.closest('[data-pack-bundle-form]');
    if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    // if (this.currentVariant) {
    //   this.form.querySelector('[data-normal-button]')?.classList.remove('d-none');
    // }
    if (this.formType == 'product-page' && this.currentVariant != false) {
        if (window.currentProduct) {
            window.currentProduct.product.currentVariant = this.currentVariant
        } else {
            window.globalVariables.product.currentVariant = this.currentVariant;
        }
    }
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option' + option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }

      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');

      this._managePackProducts();
    }
    if (_event != 'load') {
      Array.from(document.querySelectorAll('.variant-size input[type="radio"]'), input => input.classList.remove('default_selected'));

      // Remove Limited / Core title if there is no color available
      _event.target.closest('form').querySelectorAll('[data-color-type]').forEach(ele => {
        if(ele.querySelectorAll('[data-product-url]').length == ele.querySelectorAll('[data-product-url].d-none').length){
          ele.classList.add('d-none');
        }else{
          ele.classList.remove('d-none');
        }
      });

      if(this.currentVariant){
        if (this.form.querySelector('[data-widget-container-wrapper]')) {
            if (this.currentVariant.available && !this._isOutOfStock()) {
                this.form.querySelector('[data-widget-container-wrapper]').classList.remove('d-none')
            }else{
                this.form.querySelector('[data-widget-container-wrapper]').classList.add('d-none')
            }
        }

        if (this.form.querySelectorAll('upsell-item')) {
          if (this.currentVariant.available && this.form.querySelector('[data-selling_plan="null"].selected')) {
            this.form.querySelectorAll('upsell-item').forEach((ele)=>{
              ele.classList.remove('d-none');
                ele.closest('.rebuy-pdp')?.classList?.remove('d-none');
            })
          }else{
            this.form.querySelectorAll('upsell-item:not(.rebuy-pdp upsell-item)').forEach((ele)=>{
              ele.classList.add('d-none');
              ele.closest('.rebuy-pdp')?.classList?.add('d-none');
            })
          }
        }

        try{
          let unavailable_discount = _event.target.closest('[data-unavailbale-discount]')?.getAttribute('data-unavailbale-discount');
          let size = this.currentVariant.option1;

          let unavailable_sizes = this.form.querySelectorAll('[data-unavailable-discount-sizes]');
          if (unavailable_discount == 'false' && !this.form.querySelector('[data-product-type="pack"]')) {
            this.form.closest('.product-details-wrapper').querySelectorAll('.offer-tagline,.offer-badge,.widget-offer-badge:not(.pdp_pack_page .widget-offer-badge)')?.forEach((ele)=>{
              ele?.classList.remove('d-none');
            });
              this.form.closest('.product-page-container').querySelectorAll('.mobile_heading .offer-tagline').forEach((ele)=>{
                  ele.classList.remove('d-none');
              })
              this.form.closest('.product-details-wrapper').querySelectorAll('.pdp_pack_page .widget-offer-badge')?.forEach((ele)=>{
                  ele.innerHTML = ele.closest('[data-widget-offer-text]')?.getAttribute('data-widget-offer-text') || '25% OFF';
                  ele?.classList.remove('d-none');
              });
            this.form.closest('.product-details-wrapper')?.querySelectorAll('[data-regular-discounted-price]').forEach((ele)=>{
              ele.classList.remove('d-none');
            });
            this.form.closest('.product-details-wrapper')?.querySelectorAll('[data-unavailable-discounted-price]').forEach((ele)=>{
              ele.classList.add('d-none');
            })
          }else{
            // this.form.closest('.product-details-wrapper').querySelectorAll('.pdp_pack_page .widget-offer-badge')?.forEach((ele)=>{
            //    if (ele.closest('.pack-selector-4')) ele.innerHTML = '11% OFF';
            //    if (ele.closest('.pack-selector-6')) ele.innerHTML = '17% OFF';
            //    if (ele.closest('.pack-selector-10')) ele.innerHTML = '28% OFF';
            // });
            if (!this.form.querySelector('[data-product-type="pack"]')) {
              this.form.closest('.product-details-wrapper').querySelectorAll('.offer-tagline,.offer-badge,.widget-offer-badge:not(.pdp_pack_page .widget-offer-badge)')?.forEach((ele)=>{
                ele?.classList.add('d-none');
              });
              this.form.closest('.product-page-container').querySelectorAll('.mobile_heading .offer-tagline').forEach((ele)=>{
                  ele.classList.add('d-none');
              })
              this.form.closest('.product-details-wrapper')?.querySelectorAll('[data-regular-discounted-price]').forEach((ele)=>{
                ele.classList.add('d-none');
              });
              this.form.closest('.product-details-wrapper')?.querySelectorAll('[data-unavailable-discounted-price]').forEach((ele)=>{
                ele.classList.remove('d-none');
              })
            }
          }

          let unavailable_discount_tag = `${size}--true`
          unavailable_sizes.forEach((size_ele)=> {
            size_ele.closest('li')?.querySelector('.red-dot')?.classList.remove('hide');
          })
          unavailable_sizes.forEach((size_ele)=> {
            let size_attr = size_ele.getAttribute('data-unavailable-discount-sizes').trim().replace(/\n/g, '').split(',');
            if (size_attr.includes(unavailable_discount_tag)) {
              size_ele.closest('li')?.querySelector('.red-dot')?.classList.add('hide');
            }
          })
        }catch(err){
          console.log(err,'<====Error')
        }
      }
    }
    if (_event != 'load') {
      this.updateVariantStatuses(_event);
    }
  }

  _calculateRegularPackDiscountPrice = () => {
    let packnumber = parseInt(this.form.querySelector('[data-pack-number] .selected')?.closest('[data-pack-number]')?.getAttribute('data-pack-number'));
    let percentage = 0;
    let discounted_price = 0;
    let eachItemPrice = 0;
    if (packnumber == 4) {

      percentage = 11;
      discounted_price = this.currentVariant?.price * 0.89 || 0
      eachItemPrice = discounted_price / packnumber;

    }else if(packnumber == 6){

      percentage = 17;
      discounted_price = this.currentVariant?.price * 0.83 || 0
      eachItemPrice = discounted_price / packnumber;

    }else if (packnumber == 10){

      percentage = 28;
      discounted_price = this.currentVariant?.price * 0.72 || 0
      eachItemPrice = discounted_price / packnumber;

    }
    return {
      percentage,
      discounted_price : Shopify.formatMoney(discounted_price, window.globalVariables.money_format),
      eachItemPrice : Shopify.formatMoney(eachItemPrice, window.globalVariables.money_format),
    }
  }
  _managePackProducts = () => {
    let option = this.currentVariant.option1;
    this.form.querySelectorAll('[data-product-type="pack"] li:not(.selected)').forEach((ele)=>{
      let url = ele.getAttribute('data-product-url');
      let sizes = ele.getAttribute('data-available-sizes').trim().split(' ');
      var option_class = `v-${option.toLowerCase()}`;
      if (sizes.includes(option_class)) {
        ele.setAttribute('data-available-size',true);
      }else{
        let packNumber = this.form.querySelector(`[data-product-type="color"] [data-product-url="${url}"]`)?.closest('[data-pack-number]')?.getAttribute('data-pack-number');
        ele.setAttribute('data-available-size',false);
        let samePackColors = this.form.querySelectorAll(`[data-pack-number="${packNumber}"]`);
        for (const colorPack of samePackColors) {
          if(colorPack.querySelector('[data-product-url]')?.classList.contains(option_class)){
            let newURL = colorPack.querySelector('[data-product-url]').getAttribute('data-product-url')
            ele.setAttribute('data-product-url',newURL);
            break;
          }
        }
      }
    })
  }

  /**
   * Fetch Available options
   */
  updateVariantStatuses(_event) {
    const selectedOptionOneVariants = this.variantData.filter(variant => {
      let colorValue = variant.option3??variant.option2??variant.option1;
      return this.productJson.type == 'Gift Cards' ? variant.available : this.form.querySelector('[name="color"]:checked')?.value == colorValue;
    });
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 2) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      var previousOptionSelected = inputWrappers[index - 1]?.querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant =>
      variant.available && variant[`option${ index }`] === previousOptionSelected)
      .map(variantOption => variantOption[`option${index+1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  /**
   * Disabled Unavailable options
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    let productTags = this.productJson.tags || [];
    listOfAvailableOptions=Array.from(new Set(listOfAvailableOptions));

    listOfAvailableOptions = listOfAvailableOptions.filter(availableOption => {
      availableOption = availableOption.toUpperCase();
      return !productTags.includes(`OOS_${availableOption}`);
    })

    listOfOptions.forEach(input => {
      if (input.closest('[name="color"]') == null && !this.isNewBundlePack) {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.closest('li')?.classList.remove('unavailable');
        } else {
          if (!input.closest('li')?.classList.contains('mix-pack-product')) {
            input.closest('li')?.classList.add('unavailable');
          }
          if (this.form.querySelector('.variant-size.unavailable input:checked')) {
            // this.form.querySelector('.variant-size.unavailable input:checked').checked=false;
            this.form.querySelector('[name="id"]').value="";
            // this.form.querySelector('[data-normal-button]')?.classList.add('d-none');
          }

        }
      }

      let selectedInput = this.form.querySelector('.variant-size input[name=size]:checked');
      let selectedBottomInput = this.form.querySelector('.variant-size input[name="bottom size"]:checked') || this.form.querySelector('.variant-size input[name="sleep shorts size"]:checked');
      let selectedTopInput = this.form.querySelector('.variant-size input[name="top size"]:checked') || this.form.querySelector('.variant-size input[name="sleep tee size"]:checked');
      let selectedSize = selectedInput?.value;
      let inputType = selectedInput?.getAttribute('name');

        try {
            let container = this.form.closest("[data-selected-product-size]");
            if (container) {
                container.setAttribute('data-selected-product-size', typeof selectedSize !== 'undefined' ? selectedSize : '');
            }
            let bottomContainer = this.form.closest("[data-selected-bottom-size]");
            if (bottomContainer) {
                bottomContainer.setAttribute('data-selected-bottom-size', typeof selectedBottomInput?.value !== 'undefined' ? selectedBottomInput?.value : '');
            }
            let topContainer = this.form.closest("[data-selected-top-size]");
            if (topContainer) {
                topContainer.setAttribute('data-selected-top-size', typeof selectedTopInput?.value !== 'undefined' ? selectedTopInput?.value : '');
            }
        }catch (e) {
            console.log(e)
        }

      if (inputType && selectedSize && !this.isNewBundlePack) {
        this.form.querySelectorAll('.color-swatch a.color-swatch-wrapper').forEach(colorSwatch => {
          if (!colorSwatch.classList.contains(`v-${selectedSize?.toLowerCase()}`) && !colorSwatch.closest('[data-pack-style]')) {
            colorSwatch.classList.add('size-unavailable');
          } else {
            colorSwatch.classList.remove('size-unavailable')
          }
        })
      } else {
        this.form.querySelectorAll('.color-swatch a.color-swatch-wrapper').forEach(colorSwatch => {
          colorSwatch.classList.remove('size-unavailable')
        });
      }
    });
  }

  /**

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked)?.value;
    });
  }

  /**
   * change value of currentVariant when variant being changed
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
    // Array.from(document.querySelectorAll('.variant-size input[type="radio"]:checked'), input => input.checked = false);
    this.form.querySelectorAll(`[value="${this.currentVariant.option1}"]`).forEach((ele)=>{
      ele.closest('.swatch:not(.rebuy-pdp .swatch)')?.querySelector('label')?.click();
    })
    document.querySelector('.size-error-container')?.classList?.add('d-none');
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant
   * @param {element} container
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0) {
        comparePriceElement.style.display = 'none';
      } else {
        comparePriceElement.style.display = 'block';
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    try{
      let _isOutOfStock = this.currentVariant ? this._isOutOfStock() : false;
      /* ------------ Out of stoke logic ------------ */
      this.isMixPackProduct = this.form.closest('[data-style-image].mix_pack') != null ? true : false;
      if (!this.addBtn) return;
      this.addBtn.classList.remove('disabled');

      if (this.isNewBundlePack) {
          if (this.addBtn.querySelector('.add-text'))
              this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
          if (this.querySelector('.unavailable.dummy-size-container .swatch input:checked+label.other-swatch-wrapper')) {
              this.addBtn.classList.add('disabled');
              if (!this.isMixPackProduct) {
                  this.form.querySelector('[data-oos-stock]')?.classList.add('d-none');
                  this.form.querySelector('[data-qty-container]')?.classList.remove('d-none')
                  this.form.querySelector('[data-regular-stock]')?.classList.remove('d-none');
              }
          } else if (this.querySelector('.unavailable .swatch input:checked+label.other-swatch-wrapper')) {
              if (this.form.querySelector(`[data-oos-modal] #oos_variant`)) {
                  this.form.querySelector(`[data-oos-modal] #oos_variant`).value = this.currentVariant.id
              }
              if (!this.isMixPackProduct) {
                  this.form.querySelector('[data-oos-stock]')?.classList.remove('d-none');
                  this.form.querySelector('[data-qty-container]')?.classList.add('d-none')
                  this.form.querySelector('[data-regular-stock]')?.classList.add('d-none');
              }
              if(this.addBtn.querySelector('.add-text'))
                  this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
          } else {
              if (!this.isMixPackProduct) {
                  this.form.querySelector('[data-oos-stock]')?.classList.add('d-none');
                  this.form.querySelector('[data-qty-container]')?.classList.remove('d-none')
                  this.form.querySelector('[data-regular-stock]')?.classList.remove('d-none');
              }

              this.addBtn.removeAttribute('disabled');
              this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
          }
      } else {

          if (status == 'disable') {
              // this.addBtn.setAttribute('disabled', false);
              if(this.addBtn.querySelector('.add-text'))
                  this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
              if (this.querySelector('.unavailable.dummy-size-container .swatch input:checked+label.other-swatch-wrapper')) {
                  this.addBtn.classList.add('disabled');
                  if (!this.isMixPackProduct) {
                      this.form.querySelector('[data-oos-stock]')?.classList.add('d-none');
                      this.form.querySelector('[data-qty-container]')?.classList.remove('d-none')
                      this.form.querySelector('[data-regular-stock]')?.classList.remove('d-none');
                  }
              }
          }
          else if(this.currentVariant && _isOutOfStock) {
              if (this.form.querySelector(`[data-oos-modal] #oos_variant`)) {
                  this.form.querySelector(`[data-oos-modal] #oos_variant`).value = this.currentVariant.id
              }
              if (!this.isMixPackProduct) {
                  this.form.querySelector('[data-oos-stock]')?.classList.remove('d-none');
                  this.form.querySelector('[data-qty-container]')?.classList.add('d-none')
                  this.form.querySelector('[data-regular-stock]')?.classList.add('d-none');
              }
              // this.addBtn.setAttribute('disabled', true);
              if(this.addBtn.querySelector('.add-text'))
                  this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
          }
          else {
              if (!this.isMixPackProduct) {
                  this.form.querySelector('[data-oos-stock]')?.classList.add('d-none');
                  this.form.querySelector('[data-qty-container]')?.classList.remove('d-none')
                  this.form.querySelector('[data-regular-stock]')?.classList.remove('d-none');
              }

              this.addBtn.removeAttribute('disabled');
              if(this.form.classList.contains('cart-upsell-form')){
                  this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
              }else{
                  this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
              }
          }

      }

      if (this.form.querySelector('[data-widget-container-wrapper] [type="radio"]:checked')) {
        this.form.querySelector('[data-widget-container-wrapper] [type="radio"]:checked').dispatchEvent(new Event('change'));
      }

      this._manageStickyATC(status, _isOutOfStock);
      this._managePackBuilderATC(status, _isOutOfStock);

    }catch(err){
      console.error('error=>',err);
    }
  }

  _manageStickyATC(status, isOOS) {
      try {
          let stickyContainer = document.querySelector("[data-sticky-atc]");
          let stickyButton = stickyContainer.querySelector('[data-sticky-atc-button]')
          if (stickyContainer && stickyButton) {
              if (this.currentVariant?.option1) {
                  stickyContainer.querySelector('.size-title').innerText = this.currentVariant.option1.replace(/(\r\n|\n|\r)/gm, "");
                  stickyContainer.querySelector('.size-separator')?.classList?.remove('d-none');
                  stickyButton.querySelector('.btn-text').innerHTML = 'Add to cart';
                  stickyButton.setAttribute('data-sticky-atc-button', 'normal');

                  if (isOOS) {
                      stickyButton.querySelector('.btn-text').innerHTML = 'Join the waitlist';
                      stickyButton.setAttribute('data-sticky-atc-button', 'oos');
                  }
              } else {
                  stickyContainer.querySelector('.size-separator').classList.add('d-none');
                  stickyContainer.querySelector('.atc-button .btn-text').innerHTML = 'Select a size';
                  stickyButton.setAttribute('data-sticky-atc-button', 'no-size');
              }
          }
      } catch(err){
          console.log(err, 'error from sticky ATC');
      }
  }

    _managePackBuilderATC(status, isOOS) {
      try {
          let stickyBuilder = document.querySelector(".sticky-builder-container");
          if (!stickyBuilder) return;
          let builderButton = stickyBuilder?.querySelector('[data-sticky-pdp-builder-atc]')
          if (stickyBuilder && builderButton) {
              if (this.currentVariant?.option1) {
                  builderButton.querySelector('.add-text').innerHTML = 'Add to cart';
                  builderButton.setAttribute('data-sticky-pdp-builder-atc', 'normal');

                  if (isOOS) {
                      builderButton.querySelector('.add-text').innerHTML = 'Join the waitlist';
                      builderButton.setAttribute('data-sticky-pdp-builder-atc', 'oos');
                  }
              } else {
                  builderButton.setAttribute('data-sticky-pdp-builder-atc', 'no-size');
              }
          }
      } catch(err){
          console.log(err, 'error from sticky ATC');
      }
  }

    updateOfferTaglineCustom = () => {
        try {
            // Check if `window.currentProduct` and `window.currentProduct.product` exist
            if (!window.currentProduct || !window.currentProduct.product) {
                console.warn("window.currentProduct or window.currentProduct.product is not defined.");
                return; // Exit the function if the product data is not available
            }

            if (window.currentProduct.product.tags.includes('PACK')) {
                return;
            }

            // Attempt to select the current product wrapper element
            let currentProductWrapper = document.querySelector(`[data-product-container="${window.currentProduct.product.id}"]`);

            // Fallback to a generic `[data-product-container]` if the specific one is not found
            if (!currentProductWrapper) {
                currentProductWrapper = document.querySelector(`[data-product-container][data-single-product]`);
            }

            // Proceed if a product wrapper was found
            if (currentProductWrapper) {
                const singleCustomOfferTagline = currentProductWrapper.querySelector('.text-left .main-offer');

                // Check if the tagline element exists
                if (singleCustomOfferTagline) {
                    // Ensure `currentVariant` exists; default to an empty object if not
                    const variant = window.currentProduct.product.currentVariant || {};

                    // Ensure `tags` array exists; default to an empty array if not
                    const tags = window.currentProduct.product.tags || [];

                    // Check if global variables are defined, and use default values if they are not
                    const xsDiscountTag = window.globalVariables?.xs_discount_product_tag || '';
                    const xsDiscountTagline = window.globalVariables?.xs_discount_tagline || '';

                    // Set the tagline based on the variant option and tags
                    if (variant.option1 === 'XS' && tags.includes(xsDiscountTag)) {
                        singleCustomOfferTagline.innerHTML = `<strong>${xsDiscountTagline}</strong>`;
                    } else {
                        singleCustomOfferTagline.innerHTML = singleCustomOfferTagline.getAttribute('data-offer-tagline') || '';
                    }
                } else {
                    console.warn("singleCustomOfferTagline element not found.");
                }
            } else {
                console.warn("currentProductWrapper element not found.");
            }
        } catch (error) {
            console.error("Error in Utils.updateOfferTaglineCustom:", error);
        }
    }

  _isOutOfStock=()=>{
    if (
        window.globalVariables.xs_discount_enabled === 'true'
        && window.globalVariables.xs_discount_product_tag.length > 0
        && window.globalVariables.xs_discount_tagline.length > 0
    ) {
      this.updateOfferTaglineCustom()
    }
    let OOS_tags = [];
    this.productJson.tags.forEach((tag)=>{
      tag = tag.toLowerCase();
      if (tag.includes('oos')) {
        OOS_tags.push(tag);
      }
    });

    let selectedSize = this.currentVariant.option1.toLowerCase();
    let oos_size = `oos_${selectedSize}`;

    if (OOS_tags.includes(oos_size) || !this.currentVariant.available) {
      return true;
    }else{
      return false;
    }
  }
  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }

  }
}
customElements.define('variant-radios', VariantRadios);

/*----- Sticky ATC button --------------*/

class StickyPDPButton extends HTMLElement {
    connectedCallback() {
        let atcButton = this.querySelector('[data-sticky-atc-button]');
        atcButton?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            let status = event.target.closest('[data-sticky-atc-button]').getAttribute('data-sticky-atc-button');
            if (status == 'no-size') {
                const targetElement = document.querySelector('.product-form variant-radios');
                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - 200;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
                return;
            }

            if (status === 'oos') {
                document.querySelector('[data-oos-stock-btn]')?.click();
            } else {
                document.querySelector('#AddToCart-:not(.d-none #AddToCart-)')?.click();
            }
        });
    }
}

customElements.define('sticky-pdp-button', StickyPDPButton);

class StickyPDPPackBuilder extends HTMLElement {
    constructor() {
        super();

        this.pdpContainer = this.querySelector('.sticky-builder-container');
        this.handleEvents();
    }

    handleEvents() {
        document.addEventListener('rebuy:cart.change', () => {
            setTimeout(() => this.updateBuilder(), 100);
        });

        let builderAtcButton = this.querySelector('[data-sticky-pdp-builder-atc]');
        builderAtcButton?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            let status = event.target.closest('[data-sticky-pdp-builder-atc]').getAttribute('data-sticky-pdp-builder-atc');
            const sizeErrorEle = document.querySelector('.size-error-container');
            sizeErrorEle?.classList?.add('d-none');
            if (status == 'no-size') {
                const targetElement = document.querySelector('.product-form variant-radios');
                sizeErrorEle?.classList?.remove('d-none');
                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - 200;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
                return;
            }

            if (status === 'oos') {
                document.querySelector('[data-oos-stock-btn]')?.click();
            } else {
                document.querySelector('#AddToCart-:not(.d-none #AddToCart-)')?.click();
            }
        });

        document.querySelectorAll('[data-builder-item-remove]').forEach((ele) => {
            ele.addEventListener('click', (e) => {
                e.stopImmediatePropagation();

                let itemId = e.target.closest('[data-item-id]')?.getAttribute('data-item-id');
                ele.classList.add('disabled');
                if (Rebuy && itemId) {
                    const items = Rebuy?.SmartCart?.items();
                    const matchingItem = items?.find(i => String(i.id) === itemId);
                    Rebuy?.SmartCart?.removeItem(matchingItem)
                }
                setTimeout(() => {
                    ele.classList.remove('disabled');
                }, 1500)
            })
        })

        document.querySelectorAll('[data-sticky-builder-close]').forEach(ele => {
            ele.addEventListener('click', (e) => {
                e.stopImmediatePropagation();

                e.target.closest('[data-pack-builder-style]')?.classList?.add('d-none');
            })
        })
    }

    updateBuilder() {
        if (!this.pdpContainer) return;

        this.pdpContainer.classList.remove('d-none');
        const currentStyle = this.pdpContainer.getAttribute('data-pack-builder-style');
        const settings = window.globalVariables?.settings || {};
        const cartItems = Rebuy.SmartCart?.cart?.items || [];

        // Build promotion groups from settings
        const groups = {
            1: settings.promotion_1_styles?.toLowerCase()?.split("\n")?.map(style => style.trim()) || [],
            2: settings.promotion_2_styles?.toLowerCase()?.split("\n")?.map(style => style.trim()) || [],
            3: settings.promotion_3_styles?.toLowerCase()?.split("\n")?.map(style => style.trim()) || []
        };

        // Find the current product's group
        let currentGroup = Object.entries(groups).find(([_, styles]) =>
            styles.includes(currentStyle)
        );

        if (!currentGroup) return;

        const [groupNumber, groupStyles] = currentGroup;

        // Filter cart items that match current group styles
        const matchingItems = cartItems.filter(item =>
            groupStyles.includes(item.product_type?.toLowerCase())
        );

        const itemsForCards = [];
        matchingItems.forEach(item => {
            for (let i = 0; i < item.quantity; i++) {
                itemsForCards.push(item);
            }
        });

        // Loop through builder cards and populate them
        const builderCards = this.pdpContainer.querySelectorAll('[data-builder-card]');
        builderCards.forEach((card, index) => {
            const item = itemsForCards[index];
            if (item) {
                card.classList.add('has-item');
                card.setAttribute('data-item-id', item.id);
                const img = card.querySelector('img');
                if (img) {
                    const secondLastImage = item.product?.images[item.product.images.length - 1];
                    img.src = `${secondLastImage?.src || item.image}&width=300`;
                    img.alt = `${secondLastImage?.alt}`;
                }
            } else {
                card.classList.remove('has-item');

                const img = card.querySelector('img');
                if (img) {
                    img.src = '';
                    img.alt = '';
                }
            }
        });

        this.updateGroupPrices(matchingItems, this.pdpContainer);
        this.updateSuccessMessage(itemsForCards.length, this.pdpContainer, groupNumber);
    }

    updateGroupPrices(items, pdpContainer) {
        const priceContainer = pdpContainer.querySelector('.info-container:has([data-group-prices])');
        if (!priceContainer) return;

        let subtotal = 0;
        let totalSavings = 0;

        items.forEach(item => {
            subtotal += item.final_line_price || 0;
            totalSavings += item.line_level_total_discount || 0;
        });

        // Convert cents to dollars if needed
        const formatMoney = (amount) => `$${(amount / 100).toFixed(2)}`;

        priceContainer.querySelector('.subtotal').textContent = formatMoney(subtotal);

        const savingsEl = priceContainer.querySelector('.total-savings');
        const savingsLabel = priceContainer.querySelector('.total-savings-label');
        if (totalSavings > 0) {
            savingsEl.textContent = formatMoney(totalSavings);
            savingsEl.classList.remove('d-none');
            savingsLabel.classList.remove('d-none');
        } else {
            savingsEl.classList.add('d-none');
            savingsLabel.classList.add('d-none');
        }
    }

    updateSuccessMessage(itemCount, pdpContainer, groupNumber) {
        const successMessageElement = pdpContainer.querySelector('[data-builder-success-message]');
        const settings = window.globalVariables?.settings || {};

        // Fetch the appropriate prices for the current group
        const price3 = settings[`promotion_${groupNumber}_price_3pack`];
        const price5 = settings[`promotion_${groupNumber}_price_5pack`];
        const price7 = settings[`promotion_${groupNumber}_price_7pack`];

        let message = '';
        if (itemCount >= 3 && itemCount < 5) {
            message = `You’ve unlocked 3 for $${price3}!`;
        } else if (itemCount >= 5 && itemCount < 7) {
            message = `You’ve unlocked 5 for $${price5}!`;
        } else if (itemCount >= 7) {
            message = `You’ve unlocked 7 for $${price7}!`;
        }

        if (message) {
            successMessageElement.textContent = message;
            successMessageElement.classList.remove('d-none');
        } else {
            successMessageElement.classList.add('d-none');
        }
    }
}

customElements.define('sticky-pdp-pack-builder', StickyPDPPackBuilder);


function _manageRebuyPDP(){
  try{
    let rebuyWidgetId = parseInt(document.querySelector('[data-product-container] [data-rebuy-id]')?.getAttribute('data-rebuy-id'));
    let rebuyWidget = Rebuy.widgets.find(widget => widget.id == rebuyWidgetId);
    let material=document.querySelector('[data-material].active')?.getAttribute('data-material');
    if (rebuyProducts[material] == undefined || rebuyProducts[material] == null) {
      rebuyProducts[material]=Rebuy?.widgets && rebuyWidget?.data?.products
    }
    let products=rebuyProducts[material];
    if (Rebuy && products) {
      let singleProducts = products.filter(product => product.selling_plan_groups.length > 0);
      let packProducts = products.filter(product => product.selling_plan_groups.length == 0);
      let randomSingle =  Utility.pickRandomObject(singleProducts) || singleProducts[0];
      let randomPack = Utility.pickRandomObject(packProducts) || packProducts[0] || Utility.pickRandomObject(singleProducts);
      let foundSingleItem = _pickSameColorProduct(singleProducts);
      if ((randomSingle && Object.keys(randomSingle).length == 0) || !randomSingle) {
        randomSingle = Utility.pickRandomObject(packProducts)
      }
      if (randomPack?.id == randomSingle?.id) {
        randomPack = Utility.pickRandomObject(packProducts);
      }
      document.querySelectorAll('.product-details-wrapper .rebuy-product-block').forEach((ele)=>{
        ele.classList.add('d-none');
      });
      if (foundSingleItem || randomSingle) {
        document.querySelector(`.rebuy-product-block.product-id-${foundSingleItem?.id || randomSingle?.id}`)?.classList.remove('d-none');
      }
      if (randomPack) {
        document.querySelector(`.rebuy-product-block.product-id-${randomPack?.id}`)?.classList.remove('d-none');
      }
    }
  }catch(err){
    console.log(err)
  }
}

function _pickSameColorProduct(items){
  let color = window.currentProduct?.product?.variants[0]?.option2;
  let sameColorItem = items.find((product)=>{
    return product.variants[0].option2 == color;
  });
  if (!sameColorItem) {
    sameColorItem = items.find((product)=>{
      return product.variants[0].option2 == 'Black';
    });
  }
  return sameColorItem;
}

function _triggerAttentiveEvent(eventType){
    let items=[];
    if (currentForm) {
        let sellingPlanEle = currentForm.querySelector('[name="selling_plan"]');
        if (sellingPlanEle && _hasParentWithDisplayNone(sellingPlanEle)) {
            sellingPlanEle = currentForm.querySelector('[name="selling_plan_ab"]');
        }
      let sellingPlan = sellingPlanEle?.value;
      let price = window.currentProduct.product.price
      if (sellingPlan != "" && sellingPlan != undefined && sellingPlan != null){
        price = window.currentProduct.product.variants[0].selling_plan_allocations[0].price;
      }
      let obj={};
        obj['productId']=window.currentProduct.product.id;
        obj['productVariantId']=currentForm.querySelector('[name="id"]')?.value || window.currentProduct.product.variants[0].id;
        obj['product_name']=window.currentProduct.product.title;
        obj['product_image']=window.currentProduct.product.featured_image;
        obj['price']=[{
          "value": (price)/100,
          "currency": "USD"
        }]
      items.push(obj);
      if (eventType == 'add-to-cart') {
        Utility._triggerAddToCartView(items);
      }
      if (eventType == 'product-view') {
        Utility._triggerProductView(items);
      }
    }
}
function _hasParentWithDisplayNone(element) {
    let parent = element?.parentElement;

    // Traverse up the DOM to check each parent's computed display style
    while (parent) {
        const style = window.getComputedStyle(parent);
        if (style.display === 'none') {
            return true; // Return true if any parent has display: none
        }
        parent = parent.parentElement;
    }

    return false; // Return false if no parent has display: none
}

function _callRebuy(){
  let timer=0;
  try{
    let rebuyPDP = setInterval(()=>{
      if (typeof Rebuy !== 'undefined' && Rebuy?.widgets && Rebuy?.widgets[0]?.data?.products) {
        _manageRebuyPDP();
        clearInterval(rebuyPDP)
      }
      // if (timer > 120) {
      //   clearInterval(rebuyPDP)
      // }
      // timer++
    },100)
  }catch(err){
    console.log(err,'errrrr')
  }
}

if(window.globalVariables.template.includes('product') && document.querySelector('[data-product-container] [data-rebuy-id]')) {
  _callRebuy();
}

var new_seeMySizeData = null

document.addEventListener('scroll',()=>{
  let currentProductForm=document.querySelector('product-form:not(.d-none) [data-product-url].selected')?.closest('form');
  let atcSubmitForm = currentProductForm?.querySelector('[data-sticky-atc]');
    let isMobile = window.innerWidth <= 576;

  if (currentProductForm) {
    if (Utility.isElementPartiallyVisible(currentProductForm, isMobile ? 90 : 97)) {
      atcSubmitForm?.classList.add('d-none');
    }else{
      atcSubmitForm?.classList.remove('d-none');
    }
  }
});
function _replaceRelatedHtml(relatedDom) {
    const newContent = relatedDom.querySelector(`#pdp-related-products-content`)?.innerHTML;
    if (newContent && document.querySelector('#pdp-related-products-content')) {

        if (typeof newContent === 'string') {
            document.querySelector('#pdp-related-products-content').innerHTML = newContent;
        } else {
            console.error('Failed to find new content in fetched HTML.');
        }

        const relatedProductsWrapper = document.querySelector(".section-related-products");
        const relatedProdPrevBtn = relatedProductsWrapper?.querySelector(".slider-nav-btn[data-prev-button]");
        const relatedProdNextBtn = relatedProductsWrapper?.querySelector(".slider-nav-btn[data-next-button]");

        relatedProdPrevBtn?.addEventListener("click", () => {
            relatedProductsWrapper?.querySelector(".swiper-button-prev")?.click();
        });

        relatedProdNextBtn?.addEventListener("click", () => {
            relatedProductsWrapper?.querySelector(".swiper-button-next")?.click();
        });
    } else {
        console.error("Failed to find new content in fetched HTML.");
    }

    this.refreshWishlistButtons();
}

function refreshWishlistButtons() {
    let themeSchemaName = Shopify.theme["schema_name"];

    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push((swat) => {
        swat?.collectionsApi?.initializeCollections(swat, false, themeSchemaName);
    });
}
function _getRelatedProducts(relatedDomHtml, url) {
    if (!relatedDomHtml) {
        const container = document.querySelector('#pdp-related-products-content');
        const section = container.querySelector('[data-pdp-related-section-id]');
        const sectionType = section?.getAttribute('data-section-type');

        if (sectionType === 'product-recommendations') {
            const sectionId = section?.getAttribute('data-pdp-related-section-id');
            const baseUrl = section?.getAttribute('data-base-url');
            const productId = document.querySelector('[data-product-form]')?.getAttribute('data-product-id') ||
                section?.getAttribute('data-product-id');
            const intent = section?.getAttribute('data-intent');

            try {
                fetch(`${baseUrl}?section_id=${sectionId}&product_id=${productId}&intent=${intent}&limit=16`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("Failed to fetch section data");
                        }
                        return response.text();
                    })
                    .then(html => {
                        const parser = new DOMParser();
                        const relatedDom = parser.parseFromString(html, "text/html");
                        allProductJson[url]['relatedHtml'] = relatedDom;
                        if (relatedDom) {
                            _replaceRelatedHtml(relatedDom)
                        } else {
                            console.error("Failed to parse the HTML content.");
                        }
                    })
                    .catch(error => {
                        console.error("An error occurred with section data:", error);
                    });
            } catch (e) {
                console.log(e)
            }

        } else {
            console.warn("Section type is not 'product-recommendations'. Skipping fetch.");
        }
    } else {
        _replaceRelatedHtml(relatedDomHtml);
    }
}
function _replaceFormHtml(dom) {
  document.querySelectorAll('[data-product-info]').forEach((ele)=>{
    let attr = ele.getAttribute('data-product-info');
    let productInfoBlock = document.querySelector(`[data-product-info="${attr}"]`);
    if (productInfoBlock && dom.querySelector(`[data-product-info="${attr}"]`)?.innerHTML) {
      productInfoBlock.innerHTML = dom.querySelector(`[data-product-info="${attr}"]`)?.innerHTML
    }
  })
  let variant = window.currentProduct.product?.currentVariant
  window.currentProduct = JSON.parse(dom?.querySelector('[data-productJSON]')?.innerText);

  if (variant != false) {
    document.querySelector(`form [name="size"][data-handle="${variant?.option1.toLowerCase()}"]+label`)?.click();
    document.querySelector(`form [name="bottom size"][data-handle="${variant?.option1.toLowerCase()}"]+label`)?.click();
    document.querySelector(`form [name="top size"][data-handle="${variant?.option2.toLowerCase()}"]+label`)?.click();
  }
  if (window.purchaseType != false) {
    document.querySelector(`[data-purchasetype="${window.purchaseType}"] label`)?.click();
  }
  loading = false;
    if (this.addBtn) this.addBtn.classList.remove('disabled')
    document.querySelector('[data-sticky-pdp-builder-atc]')?.classList?.remove('disabled')
    _manageRebuyPDP();

  if (
      window.globalVariables.xs_discount_enabled === 'true'
      && window.globalVariables.xs_discount_product_tag.length > 0
      && window.globalVariables.xs_discount_tagline.length > 0
  ) {
    Utils.updateOfferTaglineCustom()
  }
    let currentForm = document.querySelector('product-form:not(.d-none)');
    currentForm?.handlePdpImageSlider();
    let packLabel = document.querySelector('[data-pack-selector-name]');
    if (packLabel) {
        let labelName = document.querySelector('.option_selector[data-product-url].selected')?.getAttribute('data-link-text');
        if (labelName?.includes('Pack')) {
            packLabel.innerHTML = labelName?.replace('-', ' ')?.toLowerCase();
        }
    }
  document.querySelector('[data-new-material]')?.classList.remove('pointer-events-none');

    // For keep color selected for pack selector
    _keepColorSelected();
}

function _keepColorSelected() {
    try {
        const swatch = document.querySelector('.color-swatch a.selected');
        if (!swatch) return;

        const productUrl = swatch.closest('[data-product-url]')?.dataset.productUrl;
        if (!productUrl) return;

        const labelFromBtn = document.querySelector('.product-type-toggle .option_onetime.selected')?.dataset.linkText;

        const keyByLabel = t => {
            if (t === '1-Pack') return 'single';
            const n = parseInt(t, 10);
            return Number.isFinite(n) ? `pack${n}` : null;
        };

        const currentKey = keyByLabel(labelFromBtn);
        if (currentKey) productToggleUrls[currentKey] = productUrl;

        document.querySelectorAll('.product-type-toggle .option_onetime').forEach(el => {
            const k = keyByLabel(el.dataset.linkText);
            const url = k && productToggleUrls[k];
            if (url) el.dataset.productUrl = url; // sets data-product-url
        });
    } catch (e) {
        console.log(e)
    } finally {
        document.querySelectorAll('.product-type-toggle').forEach(ele => ele.classList?.remove('disabled'));
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let currentForm = document.querySelector('product-form:not(.d-none)');
    currentForm?.handlePdpImageSlider();
})
